import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import MiniCard from '../../../../components/CardDetail/MiniCard';

import { apiCaller } from '../../../../helpers/apiCaller';
import { getSosBudServiceList } from '../../../form/PensosbudForm/action';
import { setSummary } from '../functions';

const PensosbudDashboard = ({ getSosBudServiceList, sosbudService, ...props }) => {
  const sosbudServiceList = get(sosbudService, ['data']) || [];
  const showList = ['BSBI', 'FINISH', 'LIST-SERVE', 'GRADUATE', 'MOVE'];

  useEffect(() => {
    getSosBudServiceList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderDetails = () =>
    sosbudServiceList.map((detail, idx) => {
      const { code } = detail;
      const filter = showList.find((list) => list === code);

      if (filter) {
        return (
          <StatisticDetail
            detail={detail}
            {...props}
            sosbudServiceList={sosbudServiceList}
            key={idx}
          />
        );
      }
    });

  return (
    <div className='statistic detail-container'>
      <div className='title'>Social Budaya</div>
      <div className='detail-wrap'>{renderDetails()}</div>
    </div>
  );
};

// eslint-disable-next-line react/no-multi-comp
const StatisticDetail = ({
  detail,
  history,
  startDate,
  endDate,
  reloadData,
  setReloadData,
  sosbudServiceList
}) => {
  const { title, id, code } = detail;
  const [statistic, setStatistic] = useState({
    numOfIn: String(0),
    numOfProcess: String(0),
    numOfFinish: String(0),
    numOfPending: String(0),
    numOfWaiting: String(0)
  });

  const adminLink = {
    BSBI: 'darmasiswa',
    FINISH: 'sosbud/sk/pns',
    'LIST-SERVE': 'mailing-list',
    GRADUATE: 'sosbud/sk/graduate',
    MOVE: 'sosbud/sk/transferSchool'
  };

  const loadData = () => {
    const params = {
      service_id: id,
      from: startDate,
      to: endDate
    };

    apiCaller('admin/pensosbud/statistic', 'get', undefined, true, params)
      .then((response) => {
        const statisticData = get(response, ['data', 'data']);
        const summaryData = {
          title,
          subtitle: 'Pensosbud',
          onClick: () => history.push(`/admin/${adminLink[code]}`),
          ...setSummary(statisticData)
        };
        setStatistic(summaryData);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (reloadData) {
      loadData();
      setReloadData(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reloadData]);

  const detailMiniCard = {
    title,
    subtitle: 'Document WNI',
    ...statistic
  };

  return <MiniCard detail={detailMiniCard} />;
};

StatisticDetail.propTypes = {
  history: PropTypes.object,
  detail: PropTypes.object,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  reloadData: PropTypes.bool,
  setReloadData: PropTypes.func,
  sosbudServiceList: PropTypes.array
};

PensosbudDashboard.propTypes = {
  history: PropTypes.object,
  getSosBudServiceList: PropTypes.func,
  sosbudService: PropTypes.object
};

const mapStateToProps = (state) => ({
  sosbudService: {
    status: state.sosBudServiceListReducer.status,
    error: state.sosBudServiceListReducer.error,
    data: state.sosBudServiceListReducer.data
  }
});

export default compose(
  connect(mapStateToProps, {
    getSosBudServiceList
  })
)(PensosbudDashboard);
